// src/components/PsicomotricidadeInfo.tsx
import React from 'react';
import '../../styles/especialidades.css';

const NeurologistaInfo: React.FC = () => (
    <section className="about_psicomotricidade">
        <div className="teste_zoom_two">
            <div className="about_text_psicomotricidade">
                <h2 className='sub_title'><b>Movimento, funcionalidade e qualidade de vida.</b></h2>
                <br />
                <p>A Fisioterapia é uma ciência da saúde voltada à prevenção, diagnóstico e tratamento de disfunções do movimento, da postura e das funções corporais. Seu objetivo é restaurar, manter e promover a funcionalidade e a qualidade de vida por meio de recursos terapêuticos baseados em evidências científicas.</p>
                <br />
                <p>Mais do que tratar lesões ou dores, o trabalho do fisioterapeuta envolve uma abordagem individualizada e humanizada, que considera o histórico clínico, a rotina, os hábitos e os objetivos de cada pessoa. O foco está na autonomia, na reabilitação funcional e no fortalecimento da relação entre corpo e movimento.</p>
                <br />
                <p><b>Quando procurar um fisioterapeuta?</b></p>
                <br />
                <p>O acompanhamento fisioterapêutico é indicado para:</p>
                <br/>
                
                    <li>Pessoas com dores musculares ou articulares crônicas, como lombalgias, cervicalgias, tendinites ou hérnias de disco;</li>
                    <li>Pacientes no pós-operatório ortopédico ou neurológico que precisam recuperar mobilidade e força;</li>
                    <li>Indivíduos com disfunções respiratórias, como asma, bronquite ou condições pós-COVID-19;</li>
                    <li>Mulheres no pré e pós-parto, ou com alterações do assoalho pélvico, como incontinência urinária;</li>
                    <li>Crianças, adultos e idosos com alterações do desenvolvimento motor, equilíbrio ou coordenação;</li>
                    <li>Atletas ou praticantes de atividade física que desejam prevenir lesões ou melhorar o desempenho.</li>
                
                <br />
                <p><b>Benefícios da fisioterapia personalizada</b></p>
                <br />
                <p>Com o acompanhamento de um fisioterapeuta, é possível:</p>
                
                    <li>Reduzir dores e desconfortos que afetam a rotina e o bem-estar;</li>
                    <li>Prevenir lesões e melhorar a postura, o equilíbrio e a coordenação;</li>
                    <li>Recuperar movimentos e funções após traumas ou cirurgias;</li>
                    <li>Promover a qualidade de vida em pacientes com doenças crônicas ou degenerativas;</li>
                    <li>Aumentar a consciência corporal, fortalecendo a autonomia e a autoconfiança.</li>
                
                <br />
                <p><b>Cuide do seu corpo, valorize seu movimento</b></p>
                <br />
                <p>Mais do que corrigir posturas ou aliviar dores, transformar o movimento é essencial para o cuidado com o corpo, a mente e a independência funcional. Um plano terapêutico individualizado, conduzido por um fisioterapeuta qualificado, respeita os limites e potencialidades de cada pessoa — e pode ser o começo de uma vida com mais leveza, equilíbrio e liberdade de movimento.</p>

            </div>
        </div>
    </section>
);

export default NeurologistaInfo;